module.exports = __webpack_public_path__ + "static/media/logo.3eedec80.png";